import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { IstatSettingsStoreEffects } from './effects';
import { istatSettingsReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('istatSettings', istatSettingsReducer),
    EffectsModule.forFeature([IstatSettingsStoreEffects]),
  ],
})
export class IstatSettingsStoreModule {}
